<template>
  <div class="p_t p_b">
    <TopHead title="联系我们" ></TopHead>
    <div id="map">

    </div>
    <div class="mar" v-html="jtInfo.contentInfo"></div>
    <!-- <ul class="info">
        <li>
            <div>
                <h6>联系电话</h6>
                <span>contact number</span>
            </div>
            <p>0833-5576487</p>
        </li>
        <li>
            <div>
                <h6>公司地址</h6>
                <span>address </span>
            </div>
            <p>四川省眉山市彭山区东后街49号</p>
        </li>
        <li>
            <div>
                <h6>电子邮箱</h6>
                <span>emila </span>
            </div>
            <p>tianyutiyu@163.com</p>
        </li>
    </ul> -->
    <div class="nav" @click="goMap">导航去这里</div>
  </div>
</template>
<script>

  export default {
    data() {
      return {
        jtInfo:{},
        center:[],
        lngMain:0,
        latMain:0,
        mapInfo:null,
      };
    },
    created() {
      this.getInfo()
    },
    mounted() {
      this.$nextTick(() => {
        this.getAddress()
      })
    },
    methods: {
      // 导航
      goMap(){
        if(!this.mapInfo) return this.$toast('定位失败')
        let locations = this.mapInfo.position;
        let ipGo = `https://uri.amap.com/navigation?from=${locations.lng},${locations.lat},起点&to=${this.lngMain},${this.latMain},${this.jtInfo.synopsis}&callnative=1`
        window.open(ipGo)
      },
      //获取定位信息
      getAddress(){
        let _t = this;
        AMap.plugin('AMap.Geolocation', function() {
          var geolocation = new AMap.Geolocation({
            // 是否使用高精度定位，默认：true
            enableHighAccuracy: true,
            // 设置定位超时时间，默认：无穷大
            timeout: 10000,
            // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)
            buttonOffset: new AMap.Pixel(10, 20),
            //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
            zoomToAccuracy: true,
            //  定位按钮的排放位置,  RB表示右下
            buttonPosition: 'RB'
          })

          geolocation.getCurrentPosition()
          AMap.event.addListener(geolocation, 'complete', onComplete)
          AMap.event.addListener(geolocation, 'error', onError)

          function onComplete (data) {
            // data是具体的定位信息
            _t.mapInfo = data;
          }
          function onError (data) {

          }
        })
      },
      init(){
        let _t = this;
        _t.mMap = new AMap.Map('map', {
          center:[_t.lngMain, _t.latMain],
          resizeEnable: true,
          zoom: 15,
        });

        var marker = new AMap.Marker({
          position: new AMap.LngLat(_t.lngMain, _t.latMain),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          title: ''
        });

// 将创建的点标记添加到已有的地图实例：
        _t.mMap.add(marker);
      },
      getInfo(){
        this.$api.queryContentByCode('jtxx').then(res => {
          console.log(res);
          this.jtInfo = JSON.parse(JSON.stringify(res.data));
          this.lngMain=  this.jtInfo.tags[0].toString();
          this.latMain= this.jtInfo.tags[1].toString();
          this.init()

        })
      }
    },
  }
</script>
<style lang="scss" scoped>
  .p_t{
    padding-bottom: 30px;
  }
  #map{
    width: 350px;
    height: 387px;

    margin: 12px auto 18px;
  }
  .mar{
    border-top: 1PX solid #f1f1f1;
    padding: 12px;
  }
  .info{
    height: 300px;
    border-top: 1PX solid #c5c5c5;
    text-align: center;
    padding-top: 10px;
    li{
      margin-bottom: 25px;
      >div{
        width: 100px;
        height: 37px;
        border: 1PX solid #ddf4ff;
        border-radius: 25px;
        margin: 0 auto 7px;
        background: url('../assets/images/icon7.png') no-repeat 15px center;
        background-size: 27px 23px;
        padding-left: 50px;
        text-align: left;
        h6{
          font-size: 12px;
          margin-top: 5px;
        }
        span{
          font-size: 10px;
        }
      }
      p{
        font-size: 18px;
      }
    }
    li:nth-child(2)>div{
      background: url('../assets/images/icon8.png') no-repeat 15px center;
      background-size: 27px 23px;
    }
    li:nth-child(3)>div{
      background: url('../assets/images/icon9.png') no-repeat 15px center;
      background-size: 27px 23px;
    }
  }
  .nav{
    width: 350px;
    height: 51px;
    line-height: 51px;
    background: url('../assets/images/pic8.png') no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    font-size: 18px;
    text-align: center;
    color: #fff;
  }
</style>
